import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminRoutes from "./AdminRoutes";
import BusinessRoutes from "./BusinessRoutes";
import FeedbackRoutes from "./FeedbackRoutes";
import Login from "../pages/Login";
import NotFound from "../pages/NotFound";
import Home from "../pages/Home";
import Intro from "../pages/Intro";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Home Route */}
      <Route path="/" element={<Home />} />

      {/* Introduction Page Route */}
      <Route path="/intro" element={<Intro />} />

      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      <Route exact path="/feedback/*" element={<FeedbackRoutes />} />

      {/* Admin Routes */}
      <Route path="/admin/*" element={<AdminRoutes />} />

      {/* Business Routes */}
      <Route path="/business/*" element={<BusinessRoutes />} />

      {/* Catch-All Route for Undefined Paths */}
      <Route path="*" element={<NotFound message="404: Page Not Found" />} />
    </Routes>
  );
};

export default AppRoutes;
